<script>
import { breadcrumbEventBus } from '@/main'
export default {
  data () {
    return {
      breadcrumb: []
    }
  },
  created () {
    breadcrumbEventBus.$on('breadcrumbChanged', (breadcrumb) => {
      this.breadcrumb = breadcrumb
    })
  }
}
</script>

<template>
    <div class="row">
      <div
        class="col-sm-12"
        v-if="breadcrumb.length > 0"
      >
        <nav aria-label="breadcrumb ">
          <ol class="breadcrumb breadcrumb-right-tag">
            <li
              v-bind:key="bcindex"
              class="breadcrumb-item"
              v-for="(bc, bcindex) in breadcrumb"
              :class="{active:bc.link === null}"
            >
              <router-link
                :to="bc.link"
                v-if="bc.link !== null"
              >
                {{bc.title}}
              </router-link>
              <span v-if="bc.link === null">
                {{bc.title}}
              </span>
            </li>
          </ol>
        </nav>
      </div>
    </div>
</template>

<style >
.breadcrumb {
  padding: 0.25rem 0.5rem !important;
  margin-bottom:0.25rem !important;
}
</style>
